import type { JSX, Signal } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import MobileNavItemDropdown from '~/components/Layout/Header/Mobile/MobileNavItemDropdown';
import MobileNavItemLink from '~/components/Layout/Header/Mobile/MobileNavItemLink';
import type { NavItemType } from '~/types/NavItemType';

export default component$(
  ({
    item,
    activeItem,
    mobileActive,
    level = 0,
  }: NavItemType & { mobileActive?: Signal<boolean> }): JSX.Element => {
    if (item.children && item.children.length) {
      return (
        <MobileNavItemDropdown
          item={item}
          activeItem={activeItem}
          level={level}
        />
      );
    }

    return (
      <MobileNavItemLink
        item={item}
        level={level}
        mobileActive={mobileActive}
      />
    );
  }
);
